export default "__VITE_ASSET__Dsm9dUqe__"